module.exports = __webpack_public_path__ + "static/variety-image-3-84be5cada150815931d8569e2b96010c.jpg";